import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {mediaQueries} from "@repo/shared-styles";
import {cssUrl} from "@repo/urls";

import Downloads from "./downloads.tsx";

type Props = Record<any, any>;

export default class Footer extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <View style={styles.container}>
                <View style={styles.inner}>
                    <Downloads />
                </View>
            </View>
        );
    }
}

// We need a different media query here
const reallySmallMedia = "@media screen and (max-width: 320px)";

const styles = StyleSheet.create({
    container: {
        backgroundImage: cssUrl("/images/kids/character-run-hill-bg.svg"),
        backgroundSize: "cover",
        backgroundPosition: "right 80%",
        alignItems: "center",

        // @ts-expect-error - use mediaQueries from shared-styles-package/media-queries.ts
        [reallySmallMedia]: {
            backgroundImage: cssUrl(
                "/images/kids/character-run-hill-mobile-bg.svg",
            ),
            backgroundPosition: "top",
        },
    },

    inner: {
        paddingTop: 200,
        paddingBottom: 200,
        height: 660,
        maxWidth: 940,
        width: "100%",

        [mediaQueries.mdOrSmaller]: {
            paddingTop: 80,
            paddingBottom: 0,
            height: 640,
        },

        [mediaQueries.smOrSmaller]: {
            paddingTop: 50,
            height: 450,
        },
    },
});
